import {
  selectPlayersConfirmedCombatStage,
  selectPlayersWaitedToConfirmCombatStage
} from "../../../redux/reducers/sharedStateReducer/selectors";

export const checkIfAllPlayersConfirmedCombatStage = (state) => {
  const playersWaitedToConfirmCombatStage = selectPlayersWaitedToConfirmCombatStage(state);
  const playersConfirmedCombatStage = selectPlayersConfirmedCombatStage(state);

  return playersWaitedToConfirmCombatStage.every(playerId => {
    return playersConfirmedCombatStage.includes(playerId);
  });
}